module.exports = __webpack_public_path__ + "img/train4.13e41b95.jpeg";